import React from "react"
import dayjs from "utils/dates"

// antd
import {
  Typography,
  Drawer,
  Divider,
  Flex,
  Collapse,
  List,
  Tag,
  Empty,
} from "antd"
import { ArrowLeftOutlined, LoadingOutlined } from "@ant-design/icons"

// store
import { useReservations } from "store/reservations"

// i18n
import { useTranslation } from "react-i18next"

const MenuDrawerReservations = ({ onClose, open }) => {
  const { t } = useTranslation()

  const { list } = useReservations()

  if (!list) return null

  // group reservations by month and year
  const groupedReservations = list.reduce((groups, reservation) => {
    const date = new Date(reservation.datetime.toDate())
    const monthYear = dayjs(date).format("MMMM YYYY")
    if (!groups[monthYear]) {
      groups[monthYear] = []
    }
    groups[monthYear].push(reservation)
    return groups
  }, {})

  return (
    <Drawer
      title="Menu"
      closeIcon={<ArrowLeftOutlined style={{ fontSize: 20 }} />}
      placement="right"
      onClose={onClose}
      open={open}
    >
      <Typography.Title level={4}>{t("my_reservations")}</Typography.Title>

      <Typography.Paragraph>
        {t("past_reservations_description")}
      </Typography.Paragraph>

      <Divider />

      {list.length === 0 && <Empty description={t("no_reservations_yet")} />}

      {list.length > 0 && (
        <Collapse
          defaultActiveKey={Object.keys(groupedReservations)[0]}
          accordion
          items={Object.keys(groupedReservations).map((monthYear) => ({
            key: monthYear,
            label: monthYear,
            children: (
              <div>
                <List
                  dataSource={groupedReservations[monthYear]}
                  renderItem={(reservation) => (
                    <List.Item key={reservation.id}>
                      <List.Item.Meta
                        title={
                          <div>
                            <Flex justify="space-between">
                              <Typography.Text strong>
                                {t("reservation_heading", {
                                  id: reservation.id.toUpperCase().slice(0, 4),
                                })}
                              </Typography.Text>

                              <Typography.Text>
                                {t("guests_label")} {reservation.people}
                              </Typography.Text>
                            </Flex>
                            <Typography.Text type="secondary">
                              {dayjs(reservation.datetime.toDate()).format(
                                "dddd DD.MM.YYYY HH:mm"
                              )}
                            </Typography.Text>
                          </div>
                        }
                        description={
                          <Tag
                            icon={
                              reservation.status === "created" ? (
                                <LoadingOutlined />
                              ) : null
                            }
                            style={{
                              wordBreak: "break-word",
                              whiteSpace: "pre-wrap",
                            }}
                            color={
                              reservation.status === "accepted"
                                ? "green"
                                : reservation.status === "created"
                                ? "blue"
                                : reservation.status === "cancelled-by-user"
                                ? "red"
                                : reservation.status === "refused"
                                ? "orange"
                                : "default"
                            }
                          >
                            {reservation.status === "created"
                              ? t("waiting_confirmation")
                              : reservation.status === "accepted"
                              ? t("accepted_status")
                              : reservation.status === "refused"
                              ? t("refused_status")
                              : reservation.status === "cancelled-by-user"
                              ? t("cancelled_by_user_status")
                              : t("unknown_reservation_status")}
                          </Tag>
                        }
                      />
                    </List.Item>
                  )}
                />
              </div>
            ),
          }))}
        />
      )}
    </Drawer>
  )
}

export default MenuDrawerReservations
